module.exports = __webpack_public_path__ + "static/member04-b4c2eb64440dfdd739674614a6b77d9e.png";